const _excluded = ["svgRef", "title"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }

import React from "react";

var _ref2 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M13.42 3.5L9.87 7.05a5.034 5.034 0 000 7.11c.39.39 1.03.39 1.42 0s.39-1.03 0-1.42a3.006 3.006 0 010-4.26l3.55-3.55c1.18-1.18 3.09-1.18 4.26 0s1.18 3.09 0 4.26l-2.13 2.13c-.39.39-.39 1.03 0 1.42s1.03.39 1.42 0l2.13-2.13c1.96-1.96 1.96-5.14 0-7.11s-5.14-1.97-7.1 0z"
});

var _ref3 =
/*#__PURE__*/

/*#__PURE__*/
React.createElement("path", {
  d: "M12.71 9.89c-.39.39-.39 1.03 0 1.42a3.006 3.006 0 010 4.26l-3.55 3.55a3.006 3.006 0 01-4.26 0 3.006 3.006 0 010-4.26l2.13-2.13c.39-.39.39-1.03 0-1.42s-1.03-.39-1.42 0l-2.13 2.13c-1.96 1.96-1.96 5.14 0 7.11s5.14 1.96 7.11 0L14.13 17a5.034 5.034 0 000-7.11c-.39-.39-1.03-.39-1.42 0z"
});

const SvgHyperlink = _ref => {
  let {
    svgRef,
    title
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), /*#__PURE__*/React.createElement("title", null, title), _ref2, _ref3);
};

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgHyperlink, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/hyperlink.cf7a8d5b.svg";
export { ForwardRef as ReactComponent };